"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LifecycleProvider = exports.logout = exports.lifecycle = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reduxOidc = require("redux-oidc");

var _messageBus = _interopRequireDefault(require("@dealersocket/message-bus"));

var _reduxUtils = require("@dealersocket/redux-utils");

var _userManager = require("./slice/internal/user-manager");

var _isShell = require("../utils/is-shell");

var _isMock = require("../utils/is-mock");

var _isServerSide = require("../utils/is-server-side");

var _appActivate = require("./slice/actions/app-activate.action");

var _appInit = require("./slice/actions/app-init.action");

var _dealershipChanged = require("./slice/actions/dealership-changed.action");

var _sessionUpdated = require("./slice/actions/session-updated.action");

var _lifecycle = require("./slice/lifecycle.selectors");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SHELL = 'shell'; // Silence sso session checks

_messageBus["default"].domains = ['*'];
var tokenReceived = false;
var hasError = false;

var init = function init(props) {
  var appId = props.appId,
      appSettings = props.appSettings,
      afterLogin = props.afterLogin;

  if (!appId || !appSettings || !afterLogin) {
    throw new Error("lifecycle.init function signature changed!\n      Now it expects a props object and the ARGUMENTS\n      in the afterLogin callback have been REVERSED !!!\n\n        lifecycle.init({\n          appId: string\n          appSettings: any,\n          afterLogin: (user: any, returnHash?: string) => void\n        }): void");
  }

  if (_isShell.isInShell && !_isServerSide.isServerSide) {
    // Notify shell that our hash has changed
    // This ensures that the browser back button works as expected
    window.addEventListener('hashchange', function () {
      _messageBus["default"].send(window.top, {
        from: appId,
        to: SHELL,
        task: 'appHashChanged',
        data: window.location.hash
      });
    }, false);
  }

  if (_isShell.isNotInShell && !_isServerSide.isServerSide) {
    var userManager = (0, _userManager.createUserManager)(appSettings); // redux-oidc was designed to work with browserHistory and not with hashHistory.
    // Therefore we intercept the hash route '#id_token' here before the hashHistory is initialized.
    // Once initialized the hash will change to '#/id_token' which could not be processed by the userManager.

    var hash = window.location.hash;

    if (!hash) {
      return;
    }

    if (hash.indexOf('#id_token') === 0) {
      tokenReceived = true;
      userManager.signinRedirectCallback().then(function () {
        afterLogin(userManager.getUser(), localStorage.getItem('returnHash') || undefined);
      })["catch"](function (reason) {
        console.error(reason); // eslint-disable-line no-console

        _reduxUtils.storeHelper.dispatch((0, _reduxOidc.loadUserError)());
      });
    } else if (hash.indexOf('#error=') === 0) {
      console.error(hash.substr(7)); // eslint-disable-line no-console

      hasError = true;
    }
  }
};

var setStore = function setStore(store) {
  var msg = store; // dummy use param

  msg = 'lifecycle.setStore() is deprecated, this call is not needed';
  (0, _reduxUtils.deprecated)(msg);
};

var lifecycle = {
  init: init,
  setStore: setStore
};
exports.lifecycle = lifecycle;

var loadUser = function loadUser() {
  if (hasError) {
    return new Promise(function (resolve) {
      resolve(false);
    });
  }

  var reduxStore = _reduxUtils.storeHelper.getStore();

  return (0, _userManager.getUserManager)().getUser().then(function (user) {
    if (user && !user.expired) {
      reduxStore.dispatch((0, _reduxOidc.userFound)(user));
    } else if (!tokenReceived) {
      reduxStore.dispatch((0, _reduxOidc.userExpired)());
      return false;
    }

    return true;
  })["catch"](function (error) {
    console.error("lifecycle: Error in getUser() function: ".concat(error.message)); // eslint-disable-line no-console

    reduxStore.dispatch((0, _reduxOidc.loadUserError)());
  });
};

var logout = function logout() {
  if (_isShell.isNotInShell) {
    (0, _userManager.getUserManager)().signoutRedirect();
  }
};

exports.logout = logout;

var LifecycleProviderComp =
/*#__PURE__*/
function (_React$Component) {
  _inherits(LifecycleProviderComp, _React$Component);

  function LifecycleProviderComp() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, LifecycleProviderComp);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(LifecycleProviderComp)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      userLoaded: false
    });

    _defineProperty(_assertThisInitialized(_this), "onAnyMessage", function (message) {
      var action = {
        type: "msgBus/task/".concat(message.task),
        payload: message
      };

      _reduxUtils.storeHelper.dispatch(action);
    });

    _defineProperty(_assertThisInitialized(_this), "onSessionUpdated", function (data) {
      // console.log('onSessionUpdated', { data }); // eslint-disable-line no-console
      _reduxUtils.storeHelper.dispatch((0, _sessionUpdated.sessionUpdatedAction)(data));
    });

    _defineProperty(_assertThisInitialized(_this), "onDealershipChanged", function (dealershipId, releasePool) {
      // console.log('onDealershipChanged', { dealershipId, releasePool }); // eslint-disable-line no-console
      _reduxUtils.storeHelper.dispatch((0, _dealershipChanged.dealershipChangedAction)({
        dealershipId: dealershipId,
        releasePool: releasePool
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "initAsk", function (data, respond) {
      // console.log('initAsk', { data }); // eslint-disable-line no-console
      _reduxUtils.storeHelper.dispatch((0, _appInit.appInitAction)(data));

      respond(top); // eslint-disable-line no-restricted-globals
    });

    _defineProperty(_assertThisInitialized(_this), "onActivate", function () {
      _reduxUtils.storeHelper.dispatch((0, _appActivate.appActivateAction)());
    });

    return _this;
  }

  _createClass(LifecycleProviderComp, [{
    key: "UNSAFE_componentWillMount",
    // eslint-disable-next-line camelcase
    value: function UNSAFE_componentWillMount() {
      var _this2 = this;

      if (_isShell.isNotInShell) {
        if (_isMock.isMock || _isServerSide.isServerSide) {
          this.setState({
            userLoaded: true
          });
        } else {
          loadUser().then(function (result) {
            _this2.setState({
              userLoaded: result
            });
          });
        }
      } else {
        _messageBus["default"].listen({
          from: SHELL,
          to: this.props.appId,
          task: 'init'
        }, function (message, respond) {
          return _this2.initAsk(message.data, respond);
        });

        _messageBus["default"].listen({
          from: SHELL,
          to: this.props.appId,
          task: 'activate'
        }, function () {
          return _this2.onActivate();
        });

        _messageBus["default"].listen({
          from: SHELL,
          to: this.props.appId,
          task: 'selectedDealershipChanged'
        }, function (message) {
          return _this2.onDealershipChanged(message.data.dealershipId, message.data.releasePool);
        });

        _messageBus["default"].listen({
          from: SHELL,
          to: this.props.appId,
          task: 'sessionUpdated'
        }, function (message) {
          return _this2.onSessionUpdated(message.data);
        });

        _messageBus["default"].listen({
          from: '*',
          to: this.props.appId,
          task: '*'
        }, function (message) {
          return _this2.onAnyMessage(message);
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (_isShell.isInShell && !_isServerSide.isServerSide) {
        var root = document.getElementById('root');

        if (root) {
          root.style.marginLeft = '5rem';
        } // eslint-disable-next-line no-restricted-globals


        _messageBus["default"].send(top, {
          from: this.props.appId,
          to: SHELL,
          task: 'appLoaded'
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (_isServerSide.isServerSide) {
        return _react["default"].Children.only(this.props.children);
      }

      if (_isShell.isInShell) {
        return this.props.accessToken ? _react["default"].Children.only(this.props.children) : _react["default"].createElement("h1", null, "Loading...");
      }

      return _react["default"].createElement(_reduxOidc.OidcProvider, {
        store: _reduxUtils.storeHelper.getStore(),
        userManager: (0, _userManager.getUserManager)()
      }, this.state.userLoaded ? _react["default"].Children.only(this.props.children) : _react["default"].createElement("h1", null, "Loading..."));
    }
  }]);

  return LifecycleProviderComp;
}(_react["default"].Component);

function mapStateToProps(state) {
  return {
    accessToken: (0, _lifecycle.accessTokenSelector)(state)
  };
}

var LifecycleProvider = (0, _reactRedux.connect)(mapStateToProps)(LifecycleProviderComp);
exports.LifecycleProvider = LifecycleProvider;